/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Verification_RequiredInputs */

const en_status_verification_required = /** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification Required`)
};

const es_status_verification_required = /** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación Requerida`)
};

const fr_status_verification_required = /** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification requise`)
};

const de_status_verification_required = /** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierung erforderlich`)
};

const id_status_verification_required = /** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi Diperlukan`)
};

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const ja_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const zh_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const ar_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const it_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const ru_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const pt_status_verification_required = en_status_verification_required;

/** @type {(inputs: Status_Verification_RequiredInputs) => LocalizedString} */
const ko_status_verification_required = en_status_verification_required;

/**
* | output |
* | --- |
* | "Verification Required" |
*
* @param {Status_Verification_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const status_verification_required = /** @type {((inputs?: Status_Verification_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Verification_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_verification_required(inputs)
	if (locale === "es") return es_status_verification_required(inputs)
	if (locale === "fr") return fr_status_verification_required(inputs)
	if (locale === "de") return de_status_verification_required(inputs)
	if (locale === "ja") return ja_status_verification_required(inputs)
	if (locale === "zh") return zh_status_verification_required(inputs)
	if (locale === "ar") return ar_status_verification_required(inputs)
	if (locale === "id") return id_status_verification_required(inputs)
	if (locale === "it") return it_status_verification_required(inputs)
	if (locale === "ru") return ru_status_verification_required(inputs)
	if (locale === "pt") return pt_status_verification_required(inputs)
	return ko_status_verification_required(inputs)
});